const getCurrencyData = (currencyCode, currencyDisplay, locale) => {
	const formatter = new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: currencyCode,
		currencyDisplay,
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	})

	// Format a zero amount to extract the currency symbol
	const parts = formatter.formatToParts(0)

	// Find the currency part in the formatted parts
	const currencySymbol = parts.find((part) => part.type === 'currency').value

	return currencySymbol
}

export default {
	validUrl(url) {
		const re =
			/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/
		return re.test(url)
	},

	validEmail(email) {
		const re =
			/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		return re.test(email)
	},

	dateToISO(dateString) {
		// converts dd/mm/yyyy to yyyy-mm-dd.
		return dateString ? dateString.split('/').reverse().join('-') : ''
	},

	formatNumber(value) {
		value = parseFloat(value)
		if (value >= 1000000) {
			return (value / 1000000).toFixed(1).replace(/\.?0+$/, '') + 'M'
		} else if (value >= 1000) {
			return (value / 1000).toFixed(1).replace(/\.?0+$/, '') + 'K'
		} else {
			return value.toFixed(1).replace(/\.?0+$/, '')
		}
	},

	getCurrencySymbol(currencyCode, locale) {
		return getCurrencyData(currencyCode, 'symbol', locale)
	},

	getCurrencyName(currencyCode, locale) {
		return getCurrencyData(currencyCode, 'name', locale)
	},

	getLangFlagFromLocale(locale) {
		if (locale.split('-').length > 1) {
			return locale.split('-')[1]
		} else {
			switch (locale) {
				case 'en':
					return 'gb'
				case 'da':
					return 'dk'
				default:
					return locale
			}
		}
	},

	sortChallengeTemplates(challenges) {
		// sort challenge templates (by social network and review platform)
		return challenges.sort((chaA, chaB) => {
			return chaB.display_order > chaA.display_order ? -1 : 1
		})
	},

	getFileType(url) {
		return new Promise((resolve) => {
			if (url.startsWith('data:')) {
				// "url" is base64 data
				resolve(url.substring('data:'.length, url.indexOf(';base64')))
			}
			const xhr = new XMLHttpRequest()
			xhr.open('HEAD', url, true)

			xhr.onload = function () {
				const contentType = xhr.getResponseHeader('Content-Type')
				resolve(contentType)
			}

			xhr.send()
		})
	},
}
